module.exports = __webpack_public_path__ + "img/sld_scb_7_t1_b1_dark.812b61bb.svg";